import {Component, Input, OnInit, AfterViewInit} from "@angular/core";
import {Project, Social, UrlModel} from "../../../services/model/projects.model";
import {environment} from "../../../../environments/environment";
import {NotificationService} from "../../../services/notification.service";
import {ProjectService} from "../../../services/project.service";
import {ActivatedRoute} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {TimeService} from "../../../services/time.service";
import {isNullOrUndefined} from "util";

@Component({
    selector: 'app-details-tab',
    templateUrl: './details-tab.component.html',
})
export class DetailsTabComponent implements OnInit, AfterViewInit{
    env = environment;
    is_edit: boolean;
    id: string;
    project_clone: Project;
    form: any;
    social: Social;
    @Input('project') project: Project;

    constructor(
        public projectServ: ProjectService,
        private activeR: ActivatedRoute,
        private notifServ: NotificationService,
        private formBuilder: FormBuilder,
        private timeServ: TimeService,
    ){
        this.project_clone = new Project();
        this.is_edit = false;
        this.id = this.activeR.snapshot.params['id'];
        this.social = new Social();
    }

    ngOnInit(){
        this.resetForm();
    }

    ngAfterViewInit(){
        const class_list = document.getElementById('details').classList + '';
        if(class_list.indexOf('active') > -1){
            this.is_edit = false;
        }
    }

    resetForm(){
        this.form = this.formBuilder.group({
            created_at: '',
            deadline: '',
            url: '',
            platform: 0,
            version: ''
        });
    }

    toggleEdit(status: boolean){
        if(status){
            this.form = this.formBuilder.group({
                created_at: this.project.created_at,
                deadline: this.timeServ.getDatePicketFormat(this.project.deadline),
                url: this.projectServ.getProjectUrl(this.project),
                platform: +this.project.platform,
                version: this.project.version
            });

            for(let item in this.project.social){
                this.social[item] = this.project.social[item]
            }
        }else{
            this.social = {}
        }
        this.is_edit = status;

    }

    saveDetails(){
        const new_updates = new Project();
        for(let item in this.form.value){
            if(item == 'url'){
                new_updates.url = new UrlModel();
                new_updates.url[this.projectServ.getProjectStatus(this.project)] = this.form.value[item]
            }else if(item == 'platform'){
                new_updates.platform = +this.form.value[item];
            }else{
                new_updates[item] = item == 'deadline' ? new Date(this.form.value[item]).getTime() : this.form.value[item];
            }
        }

        new_updates.social = this.social;
        this.projectServ.updateProject(this.id, new_updates, true).then(
            r => {
                this.toggleEdit(false);
                this.notifServ.sendSuccess( 'Project details have been saved');
            }
        )
    }

    isNone(key: string){
        return isNullOrUndefined(key) || key == '';
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/details-tab/details-tab.component.ts